<ion-item *ngIf="this.callcard.note?.Text">
  <ion-icon name="document-text" slot="start" size="large"></ion-icon>
  <ion-label>
    <h2>{{ callcard.note.Text | translateKeys }}</h2>
  </ion-label>
</ion-item>
